// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorPage_wrapper__bHDO9"};